import { useAuthStore } from "@/lib/swr";

// The only client-side permission gate: the admin panel. Functional roles
// (developer/tester/pm/designer) never gate anything.
export const useIsAdmin = () => {
  const user = useAuthStore((store) => store.auth?.user);
  // permissions fallback: pre-roles auth_v2 payloads in localStorage;
  // converges once admins re-login, removable afterwards.
  return (
    user?.isAdmin === true || user?.permissions?.includes("admin") === true
  );
};
